import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import Controller from '@ember/controller';

import RouterService from '@ember/routing/router-service';
import CelebrationsService from 'cio/services/celebrations';

export default class ResetPasswordController extends Controller {
  @service celebrations!: CelebrationsService;
  @service router!: RouterService;

  logoWithNameImage = new URL('cio/assets/images/logo-with-name.svg', import.meta.url).toString();
  greetingAnimationImage = new URL('cio/assets/images/greeting-animation.svg', import.meta.url).toString();

  @computed('router.currentRouteName')
  get isResetPasswordRoute(): boolean {
    return this.router.isActive('reset_password');
  }
}
